import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11637c66"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-time-wrapper" }
const _hoisted_2 = { class: "oxd-time-input" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_input = _resolveComponent("oxd-input")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_time_picker = _resolveComponent("oxd-time-picker")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oxd_input, {
        ref: "oxdInput",
        hasError: _ctx.hasError,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        value: _ctx.timeDisplay,
        placeholder: _ctx.placeholder,
        onChange: _ctx.onTimeInput,
        onClick: _ctx.toggleDropdown
      }, null, 8, ["hasError", "disabled", "readonly", "value", "placeholder", "onChange", "onClick"]),
      _createVNode(_component_oxd_icon, {
        class: _normalizeClass(_ctx.timeIconClasses),
        name: "clock",
        onClick: _ctx.toggleDropdown
      }, null, 8, ["class", "onClick"])
    ]),
    (_ctx.open)
      ? (_openBlock(), _createBlock(_component_oxd_time_picker, {
          key: 0,
          step: _ctx.step,
          modelValue: _ctx.modelValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, null, 8, ["step", "modelValue"]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.onFocusOut]
  ])
}